import { AppProgramStatusEnum } from '@/constant';
import { IPayloadUpdateLodgingProviderRequest } from '@/stores';
import {
	IPayloadCreateWorkerApplicantLodgingRequest,
	IPayloadCreateWorkerApplicantProgramRequest,
	IPayloadDeleteWorkerApplicantProcessInfoRequest,
	TUpdateWorkerApplicantRecommenderBody,
} from '@/stores/worker-applicant';
import { IPayloadCreateWorkerRecommenderApplicantRequest } from '@/stores/worker-recommender';
import {
	insertObjectIf,
	jsonToUrlParams,
	removeNilOrEmptyObj,
	trimObjectValues,
} from '@/utils';

import { omit } from 'ramda';

import api, {
	CreateLodgingBody,
	CreateWorkerChangeWorkPlaceRequest,
	GetApplicantByFranchiseExtensionStayListResponse,
	GetApplicantByFranchiseExtensionStayParams,
	GetApplicantFormInfoResponse,
	GetApplicantListByIdsParams,
	GetApplicantListByIdsResponse,
	GetApplicantListByLodgingIdResponse,
	GetDashboardExcelListBody,
	GetDashboardListParams,
	GetDashboardStatisticParams,
	GetDistrictAllowIpListResponse,
	GetExtensionStayListParams,
	GetExtensionStayListResponse,
	GetLastedAssignmentResponse,
	GetLatestAssignmentResponse,
	GetListPageParams,
	GetProviderInfoListParams,
	GetProviderInfoListResponse,
	GetPublicSalaryApplicantListParams,
	GetPublicSalaryApplicantListResponse,
	GetPublicSalaryListResponse,
	GetWorkerApplicantAssignmentListResponse,
	GetWorkerApplicantListParams,
	GetWorkerApplicantListResponse,
	GetWorkerApplicantListsDetailParams,
	GetWorkerApplicantProcessInfoListResponse,
	GetWorkerApplicantProgramListResponse,
	GetWorkerAssignmentApplicantListParams,
	GetWorkerAssignmentListParams,
	GetWorkerAuditMonitoringListParams,
	GetWorkerAuditMonitoringListResponse,
	GetWorkerChangeWorkPlaceListParams,
	GetWorkerDocumentListParams,
	GetWorkerDocumentListResponse,
	GetWorkerFranchiseAssignmentListParams,
	GetWorkerFranchiseAssignmentListResponse,
	GetWorkerFranchiseDetailResponse,
	GetWorkerFranchiseListParams,
	GetWorkerFranchiseListResponse,
	GetWorkerFranchiseLodgingListParams,
	GetWorkerFranchiseLodgingListResponse,
	GetWorkerFranchiseProgramListParams,
	GetWorkerFranchiseProgramListResponse,
	GetWorkerHistoryListParams,
	GetWorkerHistoryListResponse,
	GetWorkerLodgingApplicantListParams,
	GetWorkerLodgingApplicantListResponse,
	GetWorkerLodgingDetailResponse,
	GetWorkerLodgingListParams,
	GetWorkerLodgingListResponse,
	GetWorkerProgramApplicantListParams,
	GetWorkerProgramApplicantListResponse,
	GetWorkerProgramApplicantStatusResponse,
	GetWorkerProgramDetailResponse,
	GetWorkerProgramFranchiseListParams,
	GetWorkerProgramFranchiseListResponse,
	GetWorkerProgramFranchiseStatusResponse,
	GetWorkerProgramListParams,
	GetWorkerProgramListResponse,
	GetWorkerProgramStatusListParams,
	GetWorkerProgramStatusListResponse,
	GetWorkerRecommenderApplicantListParams,
	GetWorkerRecommenderApplicantListResponse,
	GetWorkerRecommenderDetailResponse,
	GetWorkerRecommenderListParams,
	GetWorkerRecommenderListResponse,
	GetWorkerRecommenderLodgingListResponse,
	GetWorkerSalaryLisParams,
	GetWorkerUnauthorizedDepartureLisParams,
	GetWorkerUserListParams,
	GetWorkerUseTipListParams,
	GetWorkerUseTipListResponse,
	TCreateApplicantForExtensionStayRequest,
	TCreateDistrictAllowIpRequest,
	TCreateWorkerApplicantRequest,
	TCreateWorkerExtensionStayRequest,
	TCreateWorkerFranchiseLodgingRequest,
	TCreateWorkerFranchiseProgramRequest,
	TCreateWorkerFranchiseRequest,
	TCreateWorkerProgramApplicantRequest,
	TCreateWorkerProgramFranchiseRequest,
	TCreateWorkerProgramRequest,
	TCreateWorkerRecommenderBody,
	TCreateWorkerUnauthorizedDepartureRequest,
	TCreateWorkerUserRequest,
	TCurrentSituationExcelListResponse,
	TDeleteApplicantExtensionStayRequest,
	TDeleteDistrictAllowIpRequest,
	TDeleteSettingMasterInfoBody,
	TDeleteWorkerAssignmentBody,
	TDeleteWorkerDocumentRequest,
	TDeleteWorkerUnauthorizedDepartureBody,
	TExportExcelRecommenderResponse,
	TGetApplicantAssignmentAutocompleteParams,
	TGetDataList,
	TGetEnablePublicApplicantsParams,
	TGetFranchiseAssignmentAutocompleteParams,
	TGetPublicListWithDateParams,
	TGetPublicListWithDateResponse,
	TGetSettingMasterInfoResponse,
	TGetWorkerApplicantDepartureDateBody,
	TUpdateExtensionPeriodRequest,
	TUpdateFranchiseWorkerExtensionStayRequest,
	TUpdateSettingMasterInfoBody,
	TUpdateStatusWorkerApplicantRequest,
	TUpdateWorkerAssignmentApplicantStatusBody,
	TUpdateWorkerDocumentItem,
	TUpdateWorkerSalaryRequest,
	TUploadExcelApplicantItem,
	TUploadExcelApplicantResponse,
	TUploadExcelAssignmentRequest,
	TUploadExcelAssignmentResponse,
	TUploadExcelFranchiseRequest,
	TUploadExcelLodgingItem,
	TUploadExcelPublicAssignmentRequest,
	TUploadExcelRecommenderItem,
	WorkerLodgingItem,
} from '.';

/* ---- WORKER USER START---- */
export const getWorkerDashboardList = async ({
	page,
	pageSize,
	allData = false,
	...rest
}: GetDashboardListParams) =>
	await api.post(
		`/worker/dashboard/list?${jsonToUrlParams({ page, pageSize, allData })}`,
		trimObjectValues(rest)
	);

export const getWorkerDashboardExcelList = async ({
	downloadReason,
	downloadFileName,
	...rest
}: GetDashboardExcelListBody) =>
	await api.post<TCurrentSituationExcelListResponse>(
		`/worker/program/export`,
		rest,
		{ params: { downloadReason, downloadFileName } }
	);

export const getWorkerDashboardStatistic = async ({
	...rest
}: GetDashboardStatisticParams) =>
	await api.get(`/worker/dashboard/statistical?${jsonToUrlParams(rest)}`);

export const getWorkerDashboardStatisticFranchise = async ({
	...rest
}: GetDashboardStatisticParams) =>
	await api.get(
		`/worker/dashboard/statisticalFranchise?${jsonToUrlParams(rest)}`
	);

export const getWorkerDashboardStatisticApplicant = async ({
	...rest
}: GetDashboardStatisticParams) =>
	await api.get(
		`/worker/dashboard/statisticalApplicant?${jsonToUrlParams(rest)}`
	);

export const getWorkerDashboardNotice = async () =>
	await api.get(`/worker/dashboard/notice`);

export const getWorkerDashboardInquiry = async () =>
	await api.get(`/worker/dashboard/inquiryBoard`);
/* ---- WORKER USER END---- */

/* ---- WORKER USER START---- */
export const getWorkerUserList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	...rest
}: GetWorkerUserListParams) =>
	await api.post(
		`/worker/user/list?${jsonToUrlParams({ page, pageSize, allData, sortSql })}`,
		rest
	);

export const getWorkerUserDetail = async (id: number) =>
	await api.get(`/worker/user/detail?id=${id}`);

export const deleteWorkerUser = async (ids: number[]) =>
	await api.post('/worker/user/delete', ids);

export const createWorkerUser = async (data: TCreateWorkerUserRequest) =>
	await api.post('/worker/user/create', data);
/* ---- WORKER USER END---- */

/* ---- WORKER APPLICANT START---- */

export const getWorkerApplicantList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerApplicantListParams) =>
	await api.post<GetWorkerApplicantListResponse>(
		`/worker/applicant/list?${jsonToUrlParams({ page, pageSize, allData, sortSql, downloadReason, downloadFileName })}`,
		rest
	);

export const getApplicantNameplate = async (ids: number[]) =>
	await api.post('/worker/applicant/card', ids);

export const getWorkerApplicantAssignmentList = (
	params: GetWorkerApplicantListsDetailParams
) =>
	api.get<GetWorkerApplicantAssignmentListResponse>(
		`/worker/applicant/${params.id}/assignment/list`,
		{
			params: trimObjectValues(params),
		}
	);

export const getWorkerApplicantProgramList = (
	params: GetWorkerApplicantListsDetailParams
) =>
	api.get<GetWorkerApplicantProgramListResponse>(
		`/worker/applicant/${params.id}/program/list`,
		{
			params: trimObjectValues(params),
		}
	);

export const getWorkerApplicantProcessInfoList = (
	params: GetWorkerApplicantListsDetailParams
) =>
	api.get<GetWorkerApplicantProcessInfoListResponse>(
		`/worker/applicant/${params.id}/processingInfo/list`,
		{
			params: trimObjectValues(params),
		}
	);

export const updateStatusWorkerApplicant = async (
	data: TUpdateStatusWorkerApplicantRequest[]
) => await api.post('/worker/applicant/updateStatus', data);

export const updateExtensionPeriod = async (
	data: TUpdateExtensionPeriodRequest
) => await api.post('/worker/applicant/updateExtensionPeriod', data);

export const createWorkerApplicant = async (
	data: TCreateWorkerApplicantRequest
) => await api.post('/worker/applicant/create', data);

export const createWorkerApplicantProgram = async (
	data: IPayloadCreateWorkerApplicantProgramRequest
) => await api.post('/worker/applicant/program/create', data);

export const createWorkerApplicantLodging = async (
	data: IPayloadCreateWorkerApplicantLodgingRequest
) => await api.post('/worker/applicant/lodging/create', data);

export const deleteWorkerApplicant = async (ids: number[]) =>
	await api.post('/worker/applicant/delete', ids);

export const deleteWorkerApplicantAssignment = async (ids: number[]) =>
	await api.post('/worker/applicant/assignment/delete', ids);

export const deleteWorkerApplicantProgram = async (ids: number[]) =>
	await api.post('/worker/applicant/program/delete', ids);

export const deleteWorkerApplicantLodging = async (id: number) =>
	await api.post(`/worker/applicant/${id}/lodging/delete`);

export const deleteWorkerApplicantProcessInfo = async (
	data: IPayloadDeleteWorkerApplicantProcessInfoRequest
) =>
	await api.post(
		`/worker/applicant/${data.id}/processingInfo/delete`,
		data.body
	);

export const getWorkerApplicantDetail = async (id: number, isAudit?: boolean) =>
	await api.get(`/worker/applicant/${id}/detail`, {
		params: {
			isAudit,
		},
	});

export const getWorkerApplicantRecommender = async (id: number) =>
	await api.get(`/worker/applicant/${id}/recommender`);

export const updateWorkerApplicantRecommender = async (
	data: TUpdateWorkerApplicantRecommenderBody
) => await api.post('/worker/applicant/recommender', data);

export const getWorkerApplicantLodging = async (id: number) =>
	await api.get(`/worker/applicant/${id}/lodging`);

export const getWorkerApplicantLodgingAutoFill = async (id: number) =>
	await api.get(`/worker/applicant/${id}/lodging/autofill`);

export const uploadExcelApplicant = async (
	data: TUploadExcelApplicantItem[],
	errorList: TUploadExcelApplicantResponse = []
) =>
	await api.post('/worker/applicant/import', {
		applicants: data,
		...insertObjectIf(errorList?.length > 0, {
			errorList,
		}),
	});

export const getWorkerApplicantDepartureDate = async (
	data: TGetWorkerApplicantDepartureDateBody
) => await api.post(`/worker/applicant/departureDate`, data);

export const getIssueApplicationData = async (applicantId: number) =>
	await api.get(`/common/applicantInfo?applicantId=${applicantId}`);

export const getApplicantFormInfo = async (applicantIds: number[]) =>
	await api.post<GetApplicantFormInfoResponse>(
		`/worker/applicant/formInfo`,
		applicantIds
	);

/* ---- WORKER APPLICANT END---- */

/* ---- WORKER ASSIGNMENT START---- */
export const getWorkerAssignmentList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerAssignmentListParams) =>
	await api.post(
		`/worker/assignment/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
			sortSql,
			downloadReason,
			downloadFileName,
		})}`,
		rest
	);

export const getWorkerAssignmentFranchiseList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerAssignmentListParams) =>
	await api.post(
		`/worker/assignment/franchise/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
			sortSql,
			downloadReason,
			downloadFileName,
		})}`,
		rest
	);

export const deleteWorkerAssignmentFranchise = async (ids: number[]) =>
	await api.post('/worker/assignment/franchise/delete', ids);

export const getWorkerAssignmentApplicantList = async ({
	page,
	pageSize,
	allData = false,
	...rest
}: GetWorkerAssignmentApplicantListParams) =>
	await api.get(
		`/worker/assignment/${rest?.id}/applicant/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
		})}`
	);

export const getWorkerAssignmentDetail = async (
	id: number,
	isAudit?: boolean
) =>
	await api.get(`/worker/assignment/${id}/detail`, {
		params: {
			isAudit,
		},
	});

export const deleteWorkerAssignment = async (
	body: TDeleteWorkerAssignmentBody
) => await api.post('/worker/assignment/delete', body);

export const updateWorkerAssignmentApplicantStatus = async (
	body: TUpdateWorkerAssignmentApplicantStatusBody
) => await api.post('/worker/assignment/updateStatus', body);

export const getWorkerAssignmentEvaluation = async (id: number) =>
	await api.get(`/worker/assignment/${id}/evaluation`);

export const uploadExcelAssignment = async (
	data: TUploadExcelAssignmentRequest,
	errorList: TUploadExcelAssignmentResponse = []
) =>
	await api.post('/worker/assignment/import', {
		assignments: data,
		...insertObjectIf(data[0]?.programName, {
			programName: data[0]?.programName,
		}),
		...insertObjectIf(errorList?.length > 0, {
			errorList,
		}),
	});

export const uploadExcelPublicAssignment = async (
	data: TUploadExcelPublicAssignmentRequest
) =>
	await api.post('/worker/assignment/public/import', {
		assignments: data,
		...insertObjectIf(data[0]?.programName, {
			programName: data[0]?.programName,
		}),
	});

export const getWorkerAssignmentPublicList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerAssignmentListParams) =>
	await api.post(
		`/worker/assignment/public/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
			sortSql,
			downloadReason,
			downloadFileName,
		})}`,
		rest
	);

export const getWorkerAssignmentPublicDetail = async (id: number) =>
	await api.get(`/worker/assignment/public/${id}/detail`);

export const getWorkerAssignmentPublicApplicantList = async ({
	page,
	pageSize,
	allData = false,
	...rest
}: GetWorkerAssignmentApplicantListParams) =>
	await api.get(
		`/worker/assignment/public/${rest?.id}/applicant/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
		})}`
	);

export const deleteWorkerAssignmentPublic = async (ids: number[]) =>
	await api.post('/worker/assignment/franchise/public/delete', ids);

/* ---- WORKER ASSIGNMENT END---- */

/* ---- ASSIGNMENT CALENDAR START---- */

export const getPublicListWithDate = async (
	params: TGetPublicListWithDateParams
) => {
	return await api.get<TGetPublicListWithDateResponse>(
		'/worker/assignment/publicListWithDate',
		{
			params: trimObjectValues(params),
		}
	);
};

export const getPublicAssignments = async (
	params: TGetPublicListWithDateParams
) =>
	await api.get('/worker/assignment/calendar/list', {
		params: trimObjectValues(params),
	});

export const getEnablePublicApplicants = async (
	params: TGetEnablePublicApplicantsParams
) =>
	await api.get('/worker/assignment/enablePublicApplicants', {
		params: trimObjectValues(params),
	});

export const getApplicantAssignmentAutocomplete = async (
	params: TGetApplicantAssignmentAutocompleteParams
) =>
	await api.get(`/common/applicantAssignmentAutocomplete`, {
		params: trimObjectValues(params),
	});

export const getFranchiseAssignmentAutocomplete = async (
	params: TGetFranchiseAssignmentAutocompleteParams
) =>
	await api.get(`/common/franchiseAssignmentAutocomplete`, {
		params: trimObjectValues(params),
	});

export const downloadPublicAssignmentExcel = async (
	params: TGetPublicListWithDateParams
) =>
	await api.get('/worker/assignment/public/download', {
		params: trimObjectValues(params),
	});

/* ----  ASSIGNMENT CALENDAR END---- */

/* ---- WORKER LODGING START---- */

export const getWorkerLodgingList = ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerLodgingListParams) =>
	api.post<GetWorkerLodgingListResponse>(
		`/worker/lodging/list?${jsonToUrlParams({ page, pageSize, allData, sortSql, downloadReason, downloadFileName })}`,
		rest
	);

export const getWorkerLodgingDetail = (id: number, isAudit?: boolean) =>
	api.get<GetWorkerLodgingDetailResponse>(`/worker/lodging/${id}/detail`, {
		params: {
			isAudit,
		},
	});

export const updateWorkerLodging = (id: number, body: any) =>
	api.post(`/worker/lodging/${id}/update`, trimObjectValues(body));

export const deleteWorkerLodgings = (ids: number[]) =>
	api.post(`/worker/lodging/delete`, trimObjectValues(ids));

export const getProviderInfoList = (params: GetProviderInfoListParams) =>
	api.get<GetProviderInfoListResponse>('/worker/lodging/provider/list', {
		params: trimObjectValues(params),
	});

export const createLodging = (body: CreateLodgingBody) =>
	api.post('/worker/lodging/create', trimObjectValues(body));

export const deleteWorkerLodgingById = (id: number) =>
	api.post(`/worker/lodging/${id}/delete`);

export const getApplicantListByLodgingId = (
	lodgingId: number,
	params: GetListPageParams
) =>
	api.post<GetApplicantListByLodgingIdResponse>(
		`/worker/lodging/${lodgingId}/applicant/list`,
		trimObjectValues(params)
	);

export const deleteApplicantListByLodgingId = (
	lodgingId: number,
	ids: number[]
) =>
	api.post(
		`/worker/lodging/${lodgingId}/applicant/delete`,
		trimObjectValues(ids)
	);

export const createLodgingApplicant = (lodgingId: number, body: any) =>
	api.post(
		`/worker/lodging/${lodgingId}/applicant/create`,
		trimObjectValues(body)
	);

export const uploadExcelLodging = (data: TUploadExcelLodgingItem[]) =>
	api.post('/worker/lodging/import', data);

export const getWorkerLodgingApplicantList = (
	params: GetWorkerLodgingApplicantListParams
) =>
	api.post<GetWorkerLodgingApplicantListResponse>(
		`/worker/lodging/${params.id}/applicant/list`,
		null,
		{
			params: trimObjectValues(params),
		}
	);

export const updateLodgingProvider = async (
	data: IPayloadUpdateLodgingProviderRequest
) =>
	await api.post(
		`/worker/lodging/provider/${data.providerId}/update`,
		omit(['providerId'], data)
	);

/* ---- WORKER LODGING END---- */

/* ---- WORKER RECOMMENDER START---- */

export const getWorkerRecommenderList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerRecommenderListParams) =>
	await api.post<GetWorkerRecommenderListResponse>(
		`/worker/recommender/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
			sortSql,
			downloadReason,
			downloadFileName,
		})}`,
		rest
	);

export const getWorkerRecommenderDetail = async (
	id: number,
	isAudit?: boolean
) =>
	await api.get<GetWorkerRecommenderDetailResponse>(
		'/worker/recommender/detail',
		{ params: { id, isAudit } }
	);

export const getWorkerRecommenderApplicantList = (
	params: GetWorkerRecommenderApplicantListParams
) =>
	api.get<GetWorkerRecommenderApplicantListResponse>(
		`/worker/recommender/${params.id}/applicant/list`,
		{
			params: trimObjectValues(params),
		}
	);

export const getWorkerRecommenderLodgingList = (
	params: GetWorkerApplicantListsDetailParams
) =>
	//TODO when API update
	api.get<GetWorkerRecommenderLodgingListResponse>(
		`/worker/recommender/${params.id}/lodging/list`,
		{
			params: trimObjectValues(params),
		}
	);

export const deleteWorkerRecommenders = async (ids: number[]) =>
	await api.post(`/worker/recommender/delete`, trimObjectValues(ids));

export const createWorkerRecommender = async (
	data: TCreateWorkerRecommenderBody
) => await api.post('/worker/recommender/create', data);

export const deleteWorkerRecommenderApplicant = (
	recommenderId: number,
	ids: number[]
) => api.post(`/worker/recommender/${recommenderId}/applicant/delete`, ids);

export const createWorkerRecommenderApplicant = async (
	data: IPayloadCreateWorkerRecommenderApplicantRequest
) =>
	await api.post(`/worker/recommender/${data.id}/applicant/create`, data.body);
export const uploadExcelRecommender = async (
	data: TUploadExcelRecommenderItem[]
) => await api.post('/worker/recommender/import', data);

export const exportExcelCurrentRecommender = async (
	downloadReason: string,
	downloadFileName?: string
) =>
	await api.get<TExportExcelRecommenderResponse>('/worker/recommender/export', {
		params: { downloadReason, downloadFileName },
	});

export const deleteWorkerRecommenderLodging = async (
	recommenderId: number,
	ids: number[]
) => await api.post(`/worker/recommender/${recommenderId}/lodging/delete`, ids);

/* ---- WORKER RECOMMENDER END---- */

/* ----  UNIT SETTING START ---- */

export const getUnitSetting = async (isWorker?: boolean) =>
	await api.get<TGetSettingMasterInfoResponse>(
		`/${isWorker ? 'worker' : 'common'}/unit/settingMaster`
	);

export const updateUnitSetting = async (data: TUpdateSettingMasterInfoBody) =>
	await api.post('/worker/unit/settingMaster', trimObjectValues(data));

export const deleteUnitSetting = async (data: TDeleteSettingMasterInfoBody) =>
	await api.post('/worker/unit/settingMaster/delete', data);

/* ---- UNIT SETTING END---- */

/* ---- WORKER SALARY START---- */
export const getWorkerSalaryList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerSalaryLisParams) =>
	await api.post(
		`/worker/applicantSalary/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
			sortSql,
			downloadReason,
			downloadFileName,
		})}`,
		rest
	);

export const deleteWorkerSalary = async (ids: number[]) =>
	await api.post('/worker/applicantSalary/delete', ids);

export const updateWorkerSalary = async (data: TUpdateWorkerSalaryRequest) =>
	await api.post('/worker/applicantSalary/updateBulk', data);

/* ---- WORKER SALARY END---- */

/* ----  WORKER FRANCHISE START ---- */
export const getWorkerFranchiseList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerFranchiseListParams) =>
	await api.post<GetWorkerFranchiseListResponse>(
		`/worker/franchise/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
			sortSql,
			downloadReason,
			downloadFileName,
		})}`,
		rest
	);

export const createWorkerFranchise = async (
	body: TCreateWorkerFranchiseRequest
) => await api.post('/worker/franchise/create', trimObjectValues(body));

export const getWorkerFranchiseDetail = async (id: number, isAudit?: boolean) =>
	await api.get<GetWorkerFranchiseDetailResponse>(
		`/worker/franchise/${id}/detail`,
		{
			params: {
				isAudit,
			},
		}
	);

export const deleteWorkerFranchise = async (ids: number[]) =>
	await api.post('/worker/franchise/delete', ids);

export const getWorkerFranchiseAssignmentList = async (
	id: number,
	params: GetWorkerFranchiseAssignmentListParams
) => {
	return await api.get<GetWorkerFranchiseAssignmentListResponse>(
		`/worker/franchise/${id}/assignment/list?${jsonToUrlParams(removeNilOrEmptyObj(params))}`
	);
};

export const deleteWorkerFranchiseAssignmentList = async (
	franchiseId: number,
	ids: number[]
) => await api.post(`/worker/franchise/${franchiseId}/assignment/delete`, ids);

export const getWorkerFranchiseLodgingList = async (
	id: number,
	params: GetWorkerFranchiseLodgingListParams
) => {
	return await api.get<GetWorkerFranchiseLodgingListResponse>(
		`/worker/franchise/${id}/lodging/list?${jsonToUrlParams(removeNilOrEmptyObj(params))}`
	);
};

export const deleteWorkerFranchiseLodgingList = async (
	franchiseId: number,
	ids: number[]
) => await api.post(`/worker/franchise/${franchiseId}/lodging/delete`, ids);

export const createWorkerFranchiseLodging = async (
	franchiseId: number,
	data: TCreateWorkerFranchiseLodgingRequest
) => await api.post(`/worker/franchise/${franchiseId}/lodging/create`, data);

// franchise program
export const getWorkerFranchiseProgramList = async (
	id: number,
	params: GetWorkerFranchiseProgramListParams
) => {
	return await api.get<GetWorkerFranchiseProgramListResponse>(
		`/worker/franchise/${id}/program/list?${jsonToUrlParams(removeNilOrEmptyObj(params))}`
	);
};

export const deleteWorkerFranchiseProgramList = async (
	franchiseId: number,
	ids: number[]
) => await api.post(`/worker/franchise/${franchiseId}/program/delete`, ids);

export const createWorkerFranchiseProgram = async (
	data: TCreateWorkerFranchiseProgramRequest
) => await api.post(`/worker/franchise/program/create`, data);

export const uploadExcelWorkerFranchise = async (
	data: TUploadExcelFranchiseRequest
) => await api.post('/worker/franchise/import', data);

export const getWorkerFranchiseRecommenderInfo = async (id: number) =>
	await api.get(`/worker/franchise/${id}/recommender/list`);

export const deleteWorkerFranchiseRecommender = async (
	recommenderId: number,
	ids: number[]
) =>
	await api.post(`/worker/franchise/${recommenderId}/recommender/delete`, ids);

export const getLatestAssignment = async (franchiseId: number) =>
	await api.get<GetLatestAssignmentResponse>(
		`/common/assignment/${franchiseId}/latest`
	);

export const approveWorkerFranchiseProgram = async (
	franchiseId: number,
	programIds: number[]
) =>
	await api.post(
		`/worker/franchise/${franchiseId}/program/approve`,
		programIds
	);

export const rejectWorkerFranchiseProgram = async (
	franchiseId: number,
	programIds: number[]
) =>
	await api.post(`/worker/franchise/${franchiseId}/program/reject`, programIds);

/* ---- WORKER FRANCHISE END---- */

/* ----  WORKER DOCUMENT START ---- */
export const getWorkerDocumentList = async ({
	page,
	pageSize,
	allData = false,
	...rest
}: GetWorkerDocumentListParams) =>
	await api.post<GetWorkerDocumentListResponse>(
		`/worker/document/list?${jsonToUrlParams({ page, pageSize, allData })}`,
		trimObjectValues(rest)
	);

export const deleteWorkerDocument = async (
	dataDelete: TDeleteWorkerDocumentRequest
) => await api.post('/worker/document/delete', dataDelete);

/* ---- WORKER DOCUMENT END---- */

/* ----  WORKER PROGRAM START ---- */
export const getWorkerProgramList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerProgramListParams) =>
	await api.post<GetWorkerProgramListResponse>(
		`/worker/program/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
			sortSql,
			downloadReason,
			downloadFileName,
		})}`,
		rest
	);

export const deleteWorkerProgram = async (ids: number[]) =>
	await api.post('/worker/program/delete', ids);

export const createWorkerProgram = async (body: TCreateWorkerProgramRequest) =>
	await api.post('/worker/program/create', trimObjectValues(body));

export const getWorkerProgramDetail = async (id: number, isAudit?: boolean) =>
	await api.get<GetWorkerProgramDetailResponse>(
		`/worker/program/${id}/detail`,
		{
			params: {
				isAudit,
			},
		}
	);

export const getWorkerProgramApplicantList = async (
	id: number,
	params: GetWorkerProgramApplicantListParams
) => {
	return await api.get<GetWorkerProgramApplicantListResponse>(
		`/worker/program/${id}/applicant/list?${jsonToUrlParams(removeNilOrEmptyObj(params))}`
	);
};

export const deleteWorkerProgramApplicantList = async (
	programId: number,
	ids: number[]
) => await api.post(`/worker/program/${programId}/applicant/delete`, ids);

export const createWorkerProgramApplicant = async (
	data: TCreateWorkerProgramApplicantRequest
) => await api.post(`/worker/program/${data.programId}/applicant/create`, data);

export const getWorkerProgramFranchiseList = async (
	id: number,
	params: GetWorkerProgramFranchiseListParams
) => {
	return await api.post<GetWorkerProgramFranchiseListResponse>(
		`/worker/program/${id}/franchise/list?${jsonToUrlParams(removeNilOrEmptyObj(params))}`
	);
};

export const deleteWorkerProgramFranchiseList = async (
	programId: number,
	ids: number[]
) => await api.post(`/worker/program/${programId}/franchise/delete`, ids);

export const createWorkerProgramFranchises = async (
	data: TCreateWorkerProgramFranchiseRequest
) => await api.post(`/worker/program/${data.programId}/franchise/create`, data);

export const getWorkerProgramApplicantStatus = async (id: number) => {
	return await api.get<GetWorkerProgramApplicantStatusResponse>(
		`/worker/program/${id}/applicant/status`
	);
};

export const getWorkerProgramFranchiseStatus = async (id: number) => {
	return await api.get<GetWorkerProgramFranchiseStatusResponse>(
		`/worker/program/${id}/franchise/status`
	);
};

export const getWorkerProgramStatusList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerProgramStatusListParams) =>
	await api.post<GetWorkerProgramStatusListResponse>(
		`/worker/program/status/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
			sortSql,
			downloadReason,
			downloadFileName,
		})}`,
		rest
	);

export const changeWorkerProgramApplicantStatus = async (params: {
	id: number;
	status: AppProgramStatusEnum;
}) => await api.post(`/worker/program/applicant/changeStatus`, params);

/* ---- WORKER PROGRAM END---- */

/* ---- FM1-01 DEFAULT INFO UNIT START ---- */
export const getUnitBasicInfo = (prefix: 'worker' | 'common' = 'common') =>
	api.get(`/${prefix}/unit/basicInfo`);

export const deleteFooterInfo = async (ids: number[]) =>
	await api.post(`/worker/unit/webInfo/delete`, ids);

export const deleteContractedForeignBusiness = async (ids: number[]) =>
	await api.post(`/worker/unit/deleteSigningContract`, ids);

export const addContractedForeignBusiness = async (ids: number[]) => {
	const params = {
		foreignUnitIds: ids,
	};
	return await api.post(`/worker/unit/addSigningContract`, params);
};

/* ---- WORKER UNAUTHORIZED_DEPARTURE START---- */
export const getWorkerUnauthorizedDepartureList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerUnauthorizedDepartureLisParams) =>
	await api.post(
		`/worker/unauthorizedDeparture/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
			sortSql,
			downloadReason,
			downloadFileName,
		})}`,
		rest
	);

export const deleteWorkerUnauthorizedDeparture = async (
	ids: TDeleteWorkerUnauthorizedDepartureBody
) => await api.post('/worker/unauthorizedDeparture/delete', ids);

export const getWorkerUnauthorizedDepartureDetail = async (id: number) =>
	await api.get(`/worker/unauthorizedDeparture/detail?id=${id}`);

export const createWorkerUnauthorizedDeparture = async (
	body: TCreateWorkerUnauthorizedDepartureRequest
) =>
	await api.post(
		'/worker/unauthorizedDeparture/create',
		trimObjectValues(body)
	);

/* ---- WORKER UNAUTHORIZED_DEPARTURE END---- */

/* ---- WORKER EXTENSION_STAY START---- */

export const createWorkerExtensionStay = async (
	body: TCreateWorkerExtensionStayRequest
) => await api.post('/worker/extensionStay/create', trimObjectValues(body));

export const getApplicantByFranchiseExtensionStay = (
	params: GetApplicantByFranchiseExtensionStayParams
) =>
	api.get<GetApplicantByFranchiseExtensionStayListResponse>(
		'/worker/extensionStay/applicantsByFranchise',
		{
			params: trimObjectValues(params),
		}
	);

export const getApplicantListByIds = (params: GetApplicantListByIdsParams) =>
	api.get<GetApplicantListByIdsResponse>('/common/applicantByIds', {
		params: {
			applicantIds: params.applicantIds?.join(','),
		},
	});

export const getWorkerExtensionStayDetail = async (id: number) =>
	await api.get(`/worker/extensionStay/detail?id=${id}`);

export const deleteWorkerExtensionStay = async (ids: number[]) =>
	await api.post('/worker/extensionStay/applicant/delete', ids);

export const updateFranchiseWorkerExtensionStay = async (
	data: TUpdateFranchiseWorkerExtensionStayRequest
) => await api.post('/worker/extensionStay/update', data);

export const getApplicantForExtensionStayList = async (id: number) =>
	await api.get(`/worker/extensionStay/${id}/applicant/list`);

export const deleteApplicantExtensionStay = async (
	data: TDeleteApplicantExtensionStayRequest[],
	id: number
) => await api.post(`/worker/extensionStay/${id}/applicant/delete`, data);

export const createApplicantForExtensionStay = async (
	body: TCreateApplicantForExtensionStayRequest,
	id: number
) =>
	await api.post(
		`/worker/extensionStay/${id}/applicant/create`,
		trimObjectValues(body)
	);

export const getExtensionStayList = async ({
	page,
	pageSize,
	allData = false,
	...rest
}: GetExtensionStayListParams) =>
	await api.post<GetExtensionStayListResponse>(
		`/worker/extensionStay/list?${jsonToUrlParams({ page, pageSize, allData })}`,
		rest
	);

export const deleteExtensionStay = async (id: number) =>
	await api.post(`/worker/extensionStay/${id}/delete`);

/* ---- WORKER EXTENSION_STAY END---- */

/* ---- WORKER CHANGE WORK PLACE START---- */
export const getWorkerChangeWorkPlaceList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	...rest
}: GetWorkerChangeWorkPlaceListParams) =>
	await api.post(
		`/worker/changeWorkPlace/list?${jsonToUrlParams({ page, pageSize, allData, sortSql, downloadReason, downloadFileName })}`,
		rest
	);

export const deleteWorkerChangeWorkPlace = async (ids: number[]) =>
	await api.post('/worker/changeWorkPlace/delete', ids);

export const createWorkerChangeWorkPlace = async (
	data: CreateWorkerChangeWorkPlaceRequest
) => await api.post('/worker/changeWorkPlace/create', data);

export const getWorkerChangeWorkPlaceDetail = async (id: number) =>
	await api.get(`/worker/changeWorkPlace/${id}/detail`);
/* ---- WORKER CHANGE WORK PLACE END---- */

/* ---- API MOBILE ---- */
export const getWorkerDocumentDetail = async (id: number) => {
	return await api.get(`/worker/document/${id}/detail`);
};

export const updateWorkerDocumentItem = async (
	id: number,
	body: TUpdateWorkerDocumentItem
) => {
	await api.post(`/worker/document/${id}/update`, trimObjectValues(body));
};

export const getWorkerLastedAssignment = async (id: number) =>
	await api.get<GetLastedAssignmentResponse>(
		`/worker/applicant/${id}/lastedAssignment`
	);

/* ---- M SELECT LODGING POPUP ---- */
export const getMSelectLodgingPopupList = (params: any) =>
	api.get<TGetDataList<WorkerLodgingItem>>(
		`/common/popupLodgingPaging?${jsonToUrlParams(params)}`
	);

export const getWorkerUseTipList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	...rest
}: GetWorkerUseTipListParams) => {
	return await api.post<GetWorkerUseTipListResponse>(
		`/worker/useTip/list?${jsonToUrlParams({ page, pageSize, allData, sortSql })}`,
		rest
	);
};

export const getWorkerUseTipDetail = async (id: number) => {
	return await api.get(`/worker/useTip/${id}/detail`);
};

export const getWorkerDashboardUseTip = async () =>
	await api.get(`/worker/dashboard/useTip`);

export const getWorkerDashboardNoticeReceive = async () =>
	await api.get(`/worker/dashboard/notice/receive`);

export const getWorkerHistoryList = async ({
	page,
	pageSize,
	...rest
}: GetWorkerHistoryListParams) => {
	return await api.post<GetWorkerHistoryListResponse>(
		`/worker/history/list?${jsonToUrlParams({ page, pageSize })}`,
		trimObjectValues(rest)
	);
};

/* ---- WORKER PUBLIC SALARY START---- */
export const getPublicSalaryList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	downloadReason = '',
	downloadFileName = '',
	isAudit = true,
	...rest
}: any) =>
	await api.post<GetPublicSalaryListResponse>(
		`/worker/publicSalary/list?${jsonToUrlParams({ page, pageSize, allData, sortSql, downloadReason, downloadFileName })}`,
		trimObjectValues(rest),
		{
			params: {
				isAudit,
			},
		}
	);

export const getPublicSalaryDetail = async (id: number) =>
	await api.get(`/worker/publicSalary/${id}/detail`);

export const getPublicSalaryApplicantList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	...rest
}: GetPublicSalaryApplicantListParams) =>
	await api.post<GetPublicSalaryApplicantListResponse>(
		`/worker/publicSalary/applicant/list?${jsonToUrlParams({ page, pageSize, allData, sortSql })}`,
		trimObjectValues(rest)
	);

/* ---- WORKER PUBLIC SALARY END---- */

/* ---- WORKER AUDIT MONITORING START---- */
export const getWorkerAuditMonitoringList = async ({
	page,
	pageSize,
	...rest
}: GetWorkerAuditMonitoringListParams) =>
	await api.post<GetWorkerAuditMonitoringListResponse>(
		`/common/audit/list?${jsonToUrlParams({ page, pageSize })}`,
		trimObjectValues(rest)
	);
/* ---- WORKER AUDIT MONITORING END---- */

/* ---- DISTRICT ALLOW IP START---- */
export const getDistrictAllowIpList = async () =>
	await api.get<GetDistrictAllowIpListResponse>(
		'/worker/unit/districtAllowIp/list'
	);

export const createDistrictAllowIp = async (
	data: TCreateDistrictAllowIpRequest
) => await api.post<number>('/worker/unit/districtAllowIp/create', data);

export const deleteDistrictAllowIp = async (
	ids: TDeleteDistrictAllowIpRequest
) => await api.post('/worker/unit/districtAllowIp/delete', ids);
/* ---- DISTRICT ALLOW IP END---- */
